import { createContext, useContext } from 'react';

const ScrollingColumnsContext = createContext({ multiColumn: false });

export const ScrollingColumnsProvider = ScrollingColumnsContext.Provider;

export const useScrollingColumnsContext = () => {
  return useContext(ScrollingColumnsContext);
};
